import * as types from './mutation-types'

const state = {
  exports: {
    data: [],
  },
}
const mutations = {
  [types.EXPORT_SET_EXPORTS](state, data) {
    state.exports = data
  },
}


export default {
  state,
  mutations,
}